import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    investmentAmmount: "50000",
    timePeriod: '3',
    intrestRate: '6.5',
    totalAmount: 0,
    rdErrors: null
};

const rdSlice = createSlice({
    name: 'rdCalculator',
    initialState,
    reducers: {
        setInvestmentAmounts: (state, action) => {
            state.investmentAmmount = action.payload;
        },
        setTimePeriods: (state, action) => {
            state.timePeriod = action.payload;
        },
        setIntrestRate(state, action) {
            state.intrestRate = action.payload;
        },
        setRdErrors(state, action) {
            state.rdErrors = action.payload;
        },
        setTotalValue(state, action) {
            state.totalValue = action.payload;
        },
        setTotalAmount: (state, action) => {
            state.totalAmount = action.payload;
        },
        resetRdData: (state) => {
            return initialState;
        },
    }

});
export const {
    setInvestmentAmounts,
    setTimePeriods,
    setIntrestRate,
    setRdErrors,
    setTotalValue, resetRdData, setTotalAmount
} = rdSlice.actions
export default rdSlice.reducer;
export const { setActiveCalculator } = rdSlice.actions;
